import { PaletteColorOptions, PaletteOptions } from '@material-ui/core/styles/createPalette';
/**
 * #161d42
 * #8b7c3f
 * #961132
 * #636565
 */
const primary: PaletteColorOptions = {
  light: '#161d42',
  main: '#161d42',
  dark: '#161d42',
  contrastText: '#fafafa',
};

const secondary: PaletteColorOptions = {
  light: '#E6E1F1',
  main: '#E6E1F1',
  dark: '#E6E1F1',
  contrastText: '#fff',
};

const palette: PaletteOptions = {
  primary,
  secondary,
  text: {
    secondary: '#7F8FA4'
  },
  action: {
    selected: '#E6E1F1',
  },
  background: {
    default: '#fff',
    paper: '#fff',
  },
};

export default palette;
